export enum EnvNames {
    PROD = "prod",
    PREPROD = "preprod",
    DEV = "dev"
}